<template>
  <div class="ac-content-wrapper">
    <div class="header" style="font-weight: 500;">
      Upload Logo
    </div>
    <div class="sub-header">
      This image will display on all cobranded material
    </div>
    <form
      v-if="!logoPreview && adminRole === 'admin'"
      class="dropbox-form"
      enctype="multipart/form-data"
    >
      <div class="dropbox-container">
        <input
          id="logo-upload-container"
          ref="logoRef"
          type="file"
          class="db-input"
          accept="image/*"
          aria-label="Partner Logo"
          @change="selectedImage('primary', $event.target.files)"
        >
        <div
          v-if="!errorObj.logoErr"
          class="db-header"
        >
          <img
            src="@shared/assets/img/general/upload-grey.png"
            alt="Upload"
            class="upload-icon"
          >
          <span>
            <span class="blue-underline">Click to upload</span>
            or drag and drop
          </span>
          <span>
            SVG, PNG, JPG
          </span>
        </div>
        <div
          v-else
          class="db-error"
        >
          {{ errorObj.logoErr }}
        </div>
      </div>
    </form>
    <div v-else-if="cropperPreview">
      <div class="button-dropbox-container">
        <input
          id="logo-upload-container"
          ref="logoRef"
          type="file"
          class="db-input"
          accept="image/*"
          aria-label="Partner Logo"
          @change="selectedImage('primary', $event.target.files)"
        >
        <button
          type="button"
          class="ac-upload-btn"
        >
          Upload other image
        </button>
      </div>
      <LogoCropper
        :cropperPreview="cropperPreview"
        :primaryColor="primaryColor"
        :onCropperChange="onCropperChange"
      />
    </div>
    <div
      v-else
      class="ac-preview-container"
    >
      <div
        class="ac-logo-preview-container"
        :style="{ backgroundColor: primaryColor }"
      >
        <img
          class="image-preview"
          :src="logoPreview"
          alt="Preview"
        >
      </div>
      <div
        v-if="adminRole === 'admin'"
        class="flex-row"
      >
        <div class="button-dropbox-container">
          <input
            id="logo-upload-container"
            ref="logoRef"
            type="file"
            class="db-input"
            accept="image/*"
            aria-label="Partner Logo"
            @change="selectedImage('primary', $event.target.files)"
          >
          <div class="ac-change-image-btn">
            Change Image
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LogoCropper from '@shared/components/partnerSettings/branding/LogoCropper.vue';

export default {
  name: 'UploadLogo',
  components: {
    LogoCropper,
  },
  props: {
    adminRole: String,
    primaryColor: String,
    logoPreview: String,
    cropperPreview: String,
    onChange: Function,
    selectedImage: Function,
    handleEdit: Function,
    errorObj: Object,
  },
  methods: {
    onCropperChange({ canvas }) {
      this.onChange('logoPreview', canvas.toDataURL());
    },
  },
};
</script>
